export default "__VITE_ASSET__68qJAYE3__"